import { ExpeditionStatusEnum } from '@api/ringil-api.v2.tsx';

/** A shipment as the list row has it; only the fields the rules look at. */
export interface BulkDistributionCandidate {
  id?: string;
  applicationId?: string;
  expeditionStatus?: ExpeditionStatusEnum;
}

/**
 * Only a fresh shipment can be tendered: once a distribution exists (ASSIGNING) or a carrier is on
 * it (ASSIGNED and later) the per-expedition actions apply. The backend re-checks this per item.
 */
export const isBulkDistributable = (expedition: BulkDistributionCandidate): boolean => expedition.expeditionStatus === ExpeditionStatusEnum.NEW;

/** The selection split the way the sidebar shows it: rows the job will run for, rows it will skip. */
export const splitBulkDistributionSelection = <T extends BulkDistributionCandidate>(selected: T[]): { eligible: T[]; skipped: T[] } => ({
  eligible: selected.filter(isBulkDistributable),
  skipped: selected.filter(expedition => !isBulkDistributable(expedition)),
});
